import { HttpRequest } from '@angular/common/http';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GatewayConnectionService } from 'src/app/services/apiHandler/gateway-connection/gateway-connection.service';
import { GlobalService } from 'src/app/services/helper/global-helper';
import { IdleTimerService } from 'src/app/services/helper/idleTimer/idle-timer.service';

@Component({
  selector: 'app-session-dialog',
  templateUrl: './session-dialog.component.html',
  styleUrls: ['./session-dialog.component.scss']
})
export class SessionDialogComponent {

  code: string;
  request: any;
  alreadyConnected: boolean = false;
  userName: string = "";

  constructor(@Inject(MAT_DIALOG_DATA) public data: {code: string, request?: HttpRequest<unknown>, error?: any}, private dialogRef: MatDialogRef<SessionDialogComponent>, private global: GlobalService, private apiGwConnection: GatewayConnectionService, private router: Router, private idleService: IdleTimerService){
    dialogRef.disableClose = true;
    this.code = data.code;
    this.request = data.request;
    this.global.variables.subscribe({
      next: newValue => {this.alreadyConnected = newValue.connected;}
    });
    if(data.error != undefined) {
      this.userName = data.error.userName;
    }
  }

  retryConnection() {
    let option = this.request.body.option;
    this.apiGwConnection.connectToMachine(option, true).subscribe((res) => {
        if(option.eolTestDone === false) {
          this.global.comission.next({enabled: true});
        }
        this.idleService.startWatching();
        this.router.navigate(['/menu']);
        this.global.machineNumber.next({ number: option.serialNumber, id: option.id, series: option.machineSeries});
        if(option.type.line == 'crane') {
          option.type.line = 'green';
        }
        this.global.machineInfos.next({line: option.type.line, name: option.type.name, engine: option.engineType});
        this.global.variables.next({connected: true});
        this.global.error.next({occurred: false});
        this.dialogRef.close();
    });
  }

  cancelAttempt(){
    this.global.error.next({occurred: false});
    this.dialogRef.close();
  }

  closeError(){
    this.router.navigateByUrl("");
    this.global.error.next({occurred: false});
    this.dialogRef.close();
  }

}
